import { callApi } from "@amplio-common/api";
import { schema } from "normalizr";


const usersSchema = new schema.Entity("users", {}, {
  idAttribute: user => user.id,
});

const studentSchema = new schema.Entity("students", {
  // goal_set: clinicalContentShemas.GOAL_ARRAY
}, {
  idAttribute: user => user.id,
});

const therapistSchema = new schema.Entity("therapists", {
}, {
  idAttribute: user => user.id,
});


export const Schemas = {
  USER_ARRAY: [usersSchema],
  USER: usersSchema,
  STUDENT: studentSchema,
  STUDENT_ARRAY: [studentSchema],
  THERAPIST: therapistSchema,
  THERAPIST_ARRAY: [therapistSchema],
};

export const userNetworkDeviceDetailsTest = (data) => callApi("users/network_device_details_test/", {
  method: "POST",
  type: "JSON",
  body: data,
});

export const loadTherapistTodaysSessions = (userId) => callApi(`users/${userId}/todays_sessions/`, { method: "GET" });

export const loadStudent = (studentId, useSchema = true) => callApi(`students/${studentId}/`, { method: "GET" },
  useSchema ? Schemas.STUDENT : null);

  
export const updateStudent = (studentId, student, useSchema = true) => callApi(`students/${studentId}/`, {
  method: "PATCH",
  type: "JSON",
  body: { ...student },
}, useSchema ? Schemas.STUDENT : null);

export const loadAllStudentsNoInactive = (therapistId, useSchema = false) => callApi(`students/?all=false&inactive=false${therapistId ? `&therapist_id=${therapistId}` : ""}`, { method: "GET" }, useSchema ? Schemas.STUDENT_ARRAY : null);

export const loadUserCalendarCreateOptions = (userId, tId) => callApi(`users/${userId}/calendar_options/${tId ? `?treatment_id=${tId}` : ""}`, { method: "GET" });
